// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:578423bc-a561-4188-a393-d7163011728e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_wh7PDgaL3",
    "aws_user_pools_web_client_id": "2sn1m0fgdv0h1ntltd3r8jo8p6",
    "oauth": {},
    "aws_content_delivery_bucket": "chess-variant-20191210113159-hostingbucket-develop",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://chess-variant-20191210113159-hostingbucket-develop.s3-website-us-east-1.amazonaws.com",
    "aws_appsync_graphqlEndpoint": "https://3cjwxvmjunaipkn73ypwattvxm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-hriixp7oqzfglhsrmx4zzeftoi",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://bjkfzp89s4.execute-api.us-east-1.amazonaws.com/develop",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
